(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('SettingsController', SettingsController);

	SettingsController.$inject = ['$window', '$log', 'lodash', 'UserService', 'WineTable', 'BUILD_NUMBER', 'userPouch', 'systemPouch', '$mdDialog', '$scope', 'Utils'];

	function SettingsController($window, $log, lodash, UserService, WineTable, BUILD_NUMBER, userPouch, systemPouch, $mdDialog, $scope, Utils) {

		/* jshint validthis: true */
		var self = this;

		self.$localStorage = UserService.$localStorage;

		self.table = WineTable;

		self.build = (BUILD_NUMBER === 'min.js') ? 'local' : BUILD_NUMBER;

		self.themeOptions = {
			colors: [
				{name: "amber", display: "Amber"},
				{name: "blue", display: "Blue"},
				{name: "blue-grey", display: "Blue - Grey"},
				{name: "light-blue", display: "Blue - Light"},
				{name: "brown", display: "Brown"},
				{name: "cyan", display: "Cyan"},
				{name: "green", display: "Green"},
				{name: "light-green", display: "Green - Light"},
				{name: "grey", display: "Grey"},
				{name: "indigo", display: "Indigo"},
				{name: "lime", display: "Lime"},
				{name: "orange", display: "Orange"},
				{name: "deep-orange", display: "Orange - Deep"},
				{name: "pink", display: "Pink"},
				{name: "purple", display: "Purple"},
				{name: "deep-purple", display: "Purple - Deep"},
				{name: "red", display: "Red"},
				{name: "teal", display: "Teal"},
				{name: "yellow", display: "Yellow"}
			]
		};

		self.localeOptions = {
			available: [],
			currentLocale: '',
			localeExample: '',
		};

		self.printers = [];

		self.customFieldInput = null;

		self.customFields = [];

		/**
		 * Setup default field settings.
		 * These are the field settings at the user account level (stored on userdoc).
		 * They are all set to true because we can't assume existing users don't want to see them.
		 * @TODO - setup onboarding wizard to adjust these fields.
		 * */
		self.fields = {
			"cases": true,
			"maker": true,
			"vineyard": true,
			"url": true,
			"grapes": true,
			"bottleSize": true,
			"abv": true,
			"body": true,
			"rating": {
				"user": {
					"general": true,
					"point": true
				},
				"other": {
					"advocate": true,
					"spectator": true,
					"enthusiast": true,
					"vinous": true,
					"suckling": true
				}
			},
			"cellar": {
				"ids": {
					"custom": true,
					"barcode": true
				}
			}
		};

		self.reloadPage = reloadPage;
		self.updateTableColumnSettings = updateTableColumnSettings;
		self.confirmWipe = confirmWipe;
		self.changePassword = changePassword;
		self.addCustomField = addCustomField;
		self.removeCustomField = removeCustomField;
		self.setLocale = setLocale;
		self.updateUserFieldSettings = updateUserFieldSettings;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){
			try {
				//$window.dymo.label.framework.trace = 1;
                $window.dymo.label.framework.init(function () {
					try {
						$window.dymo.label.framework.getPrintersAsync().then(function (printers) {
							// Successful result, printers variable has a list of all supported by the DYMO Label Framework
							$scope.$apply(function () {
								self.printers = printers;
							});
							$log.debug('Printers found', self.printers);
						});

					} catch (err){
						$log.warn('Dymo printer init error', err);
					}
                });
			} catch (err){
				$log.warn('Dymo printer error', err);
			}

			UserService.getSetting('fields', {}).then(function(data){
				self.fields = lodash.merge(self.fields, data);
			});

			_loadCustomFields();

			_setupLocaleSettings();
		}

		/**
		 * setup data for settings field
		 * - get available locales
		 * - get locale from couch
		 * - set current locale
		 * @private
		 */
		function _setupLocaleSettings(){
			// available locales
			self.localeOptions.available = $window.numeral.locales;

			// load from couch
			UserService.getLocale().then(function(locale){
				self.localeOptions.currentLocale = locale;

				// switch between locales
				self.setLocale();
			});
		}

		/**
		 * call user service to set local in couch & update example
		 */
		function setLocale(){
			UserService.setLocale(self.localeOptions.currentLocale);
			self.localeOptions.localeExample =  $window.numeral('9999.99').format('$0,0.00');
		}

		function _loadCustomFields(){
			UserService.getCustomFields().then(function(customFields){
				$log.debug('User Setting: customFields', customFields);
				self.customFields = customFields;
			});
		}

		function reloadPage(){
			$window.location.reload();
		}

		function updateTableColumnSettings(){
			self.table.setNumHeaderColumns(self.$localStorage.columns);
		}

		function wipe(){

			var remote = userPouch.remote();

			$window.Intercom('shutdown');

			WineTable.setWines([]);

            userPouch.cancelReplication()
				.then(userPouch.destroy)
				.then(systemPouch.cancelReplication)
				.then(systemPouch.destroy)
				.then(function(){
					$log.debug('Logging user out...', remote);
					return remote ? remote.logout() : true;
				})
                .catch(function(err){
                    $log.error('Issue logging out', err);
                })
				.finally(function(){
                    $log.debug('Refreshing and sending user to login page...');
                    // full refresh so local pouches get reinitialized
                    $window.location.reload();
				});
		}

		function confirmWipe(event){
			var confirm = $mdDialog.confirm()
				.title('Would you like to delete all local data?')
				.textContent('This will only delete your local data on your browser. It will not delete your wine data stored in your central database. It WILL log you out and synchronizing your data when you log back in will take longer.')
				.ariaLabel('Delete Local Data')
				.targetEvent(event)
				.ok('Confirm Delete')
				.cancel('Cancel');

			$mdDialog.show(confirm).then(function() {
				wipe();
			}, function() {
				// do nothing
			});
		}

		function changePassword(){
			Utils.go('password/change');
		}

		function addCustomField(){

			if (lodash.isEmptyOrNull(self.customFieldInput)){
				return false;
			}

			UserService.addCustomFieldSetting(self.customFieldInput).then(function(){
				self.customFieldInput = '';
				_loadCustomFields();
			});
		}

		function removeCustomField(customField){
			UserService.removeCustomFieldSetting(customField).then(function(){
				_loadCustomFields();
			});
		}

		function updateUserFieldSettings(fieldName, val){
			$log.debug('Updating user account settings', fieldName, val);
            UserService.updateSetting('fields.' + fieldName, val);
		}
	}

})();
